import { serviceList } from "../data/services";
import { useMobile } from "../hooks/useMobile";
import {
  KAP, Ac, Dugme, Dizin, DizinSatir,
  ALTIN, ALTIN_PARLAK, ALTIN_KOYU, INK, INK_2, INK_3,
  KAGIT, KAGIT_2, CIZGI, DISPLAY, GOVDE,
  BLOK,} from "./Ui";

/* =============================================================
   HİZMET DETAY SAYFASI PARÇALARI  (9 sayfa bunu kullanıyor)

   Eski düzende her bölümün üstünde küçük büyük harfli bir etiket
   vardı ("TANIYOR MUSUN?", "NASIL ÇALIŞIYORUZ", "NE KAZANIRSIN"),
   adımlar dönüşümlü dört renkle boyanıyordu ve sorunların yanında
   emoji ikonlar duruyordu. Yeni dilde:
     - etiketler kalktı, başlık kendi işini yapıyor
     - tek vurgu rengi
     - kart ızgarası yerine numaralı liste ve saç teli çizgiler
     - emoji yok, numaralı sıra var
   ============================================================= */

/* ---------- kahraman: koyu blok ---------- */
export function ServiceHero({ badge, title, highlight, subtitle }) {
  const mobil = useMobile();
  return (
    <section style={{
      background: BLOK, color: KAGIT,
      padding: mobil ? "56px 0 64px" : "84px 0 96px",
    }}>
      <div style={KAP}>
        {badge && (
          <p style={{
            fontFamily: DISPLAY, fontSize: 11.5, fontWeight: 700,
            letterSpacing: "0.14em", textTransform: "uppercase",
            color: ALTIN_PARLAK, marginBottom: 22,
          }}>{badge}</p>
        )}
        <h1 style={{
          fontSize: mobil ? "clamp(32px,8vw,44px)" : "clamp(38px,5vw,66px)",
          maxWidth: "16ch", color: KAGIT,
        }}>
          {title}{" "}
          {highlight && <span style={{ color: ALTIN_PARLAK }}>{highlight}</span>}
        </h1>
        {subtitle && (
          <p style={{
            fontFamily: GOVDE, fontSize: mobil ? 16 : 18.5, marginTop: 24,
            color: "rgba(251,250,246,.66)", maxWidth: "56ch", lineHeight: 1.65,
          }}>{subtitle}</p>
        )}
      </div>
    </section>
  );
}

/* ---------- sorunlar: numaralı, ikonsuz ---------- */
export function ProblemSection({ title, items }) {
  const mobil = useMobile();
  if (!items || !items.length) return null;
  return (
    <section style={{ padding: mobil ? "56px 0" : "84px 0" }}>
      <div style={KAP}>
        <Ac>
          <h2 style={{ fontSize: "clamp(28px,3.4vw,42px)", maxWidth: "18ch" }}>{title}</h2>
        </Ac>
        <div style={{
          marginTop: 34, borderTop: `1px solid ${CIZGI}`,
          display: "grid", gridTemplateColumns: mobil ? "1fr" : "repeat(3,1fr)",
        }}>
          {items.map((it, i) => (
            <Ac key={i} gecikme={i * 70}>
              <div style={{
                height: "100%",
                padding: mobil ? "22px 0 24px" : "26px 30px 30px 0",
                borderRight: !mobil && i < items.length - 1 ? `1px solid ${CIZGI}` : 0,
                borderBottom: mobil && i < items.length - 1 ? `1px solid ${CIZGI}` : 0,
              }}>
                <span className="sayi" style={{
                  fontFamily: DISPLAY, fontSize: 12, fontWeight: 700, color: ALTIN_KOYU,
                }}>{String(i + 1).padStart(2, "0")}</span>
                <p style={{
                  fontFamily: GOVDE, fontSize: 15.5, color: INK_2,
                  lineHeight: 1.6, marginTop: 12,
                }}>{it.text}</p>
              </div>
            </Ac>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ---------- çözüm adımları ---------- */
export function SolutionSection({ title, steps, note }) {
  const mobil = useMobile();
  if (!steps || !steps.length) return null;
  return (
    <section style={{ background: KAGIT_2, padding: mobil ? "56px 0" : "84px 0" }}>
      <div style={KAP}>
        <Ac>
          <h2 style={{ fontSize: "clamp(28px,3.4vw,42px)", maxWidth: "18ch" }}>{title}</h2>
        </Ac>
        <div style={{
          marginTop: 34, borderTop: `1px solid ${CIZGI}`,
          display: "grid", gridTemplateColumns: mobil ? "1fr" : "repeat(2,1fr)",
        }}>
          {steps.map((s, i) => (
            <Ac key={i} gecikme={(i % 2) * 70}>
              <div style={{
                height: "100%", display: "grid", gridTemplateColumns: "38px 1fr", gap: 16,
                padding: mobil ? "22px 0 24px" : (i % 2 === 0 ? "26px 34px 28px 0" : "26px 0 28px 34px"),
                borderBottom: `1px solid ${CIZGI}`,
                borderLeft: !mobil && i % 2 === 1 ? `1px solid ${CIZGI}` : 0,
              }}>
                <span className="sayi" style={{
                  fontFamily: DISPLAY, fontSize: 12, fontWeight: 700, color: ALTIN_KOYU,
                }}>{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 style={{ fontSize: 18.5, marginBottom: 7 }}>{s.title}</h3>
                  <p style={{ fontFamily: GOVDE, fontSize: 15, color: INK_2,
                              lineHeight: 1.58 }}>{s.desc}</p>
                </div>
              </div>
            </Ac>
          ))}
        </div>
        {note && (
          <Ac>
            <p style={{
              fontFamily: GOVDE, fontSize: 15, color: INK_2, marginTop: 26,
              paddingLeft: 18, borderLeft: `2px solid ${ALTIN}`, maxWidth: "70ch",
            }}>{note}</p>
          </Ac>
        )}
      </div>
    </section>
  );
}

/* ---------- ne kazanırsın ---------- */
export function OutcomesSection({ items }) {
  const mobil = useMobile();
  if (!items || !items.length) return null;
  return (
    <section style={{ padding: mobil ? "56px 0" : "84px 0" }}>
      <div style={KAP}>
        <Ac>
          <h2 style={{ fontSize: "clamp(28px,3.4vw,42px)", maxWidth: "16ch" }}>
            Bu hizmetin sonunda elinizde ne olacak
          </h2>
        </Ac>
        <div style={{
          marginTop: 30, borderTop: `1px solid ${CIZGI}`,
          display: "grid", gridTemplateColumns: mobil ? "1fr" : "repeat(2,1fr)",
        }}>
          {items.map((t, i) => (
            <Ac key={i} gecikme={(i % 2) * 60}>
              <div style={{
                display: "flex", gap: 14, alignItems: "flex-start", height: "100%",
                padding: mobil ? "18px 0" : (i % 2 === 0 ? "20px 34px 20px 0" : "20px 0 20px 34px"),
                borderBottom: `1px solid ${CIZGI}`,
                borderLeft: !mobil && i % 2 === 1 ? `1px solid ${CIZGI}` : 0,
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                     stroke={ALTIN_KOYU} strokeWidth="2" style={{ flex: "none", marginTop: 3 }}>
                  <path d="M4 12.5l5 5L20 6.5" />
                </svg>
                <span style={{ fontFamily: GOVDE, fontSize: 15.5, color: INK_2,
                               lineHeight: 1.55 }}>{t}</span>
              </div>
            </Ac>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ---------- kapanış ---------- */
export function ServiceCTA({ onNavigate }) {
  const mobil = useMobile();
  return (
    <section style={{ background: BLOK, color: KAGIT, padding: mobil ? "56px 0" : "84px 0" }}>
      <div style={KAP}>
        <Ac>
          <h2 style={{ fontSize: "clamp(30px,4vw,50px)", maxWidth: "15ch", color: KAGIT }}>
            Bu hizmeti <span style={{ color: ALTIN_PARLAK }}>konuşalım.</span>
          </h2>
          <p style={{
            fontFamily: GOVDE, fontSize: 17, marginTop: 18,
            color: "rgba(251,250,246,.65)", maxWidth: "46ch",
          }}>
            Ücretsiz analiz görüşmesinde ihtiyacınızı birlikte çıkarıyoruz.
            Satış konuşması değil, tespit toplantısı.
          </p>
          <div style={{ marginTop: 28, display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Dugme tur="altin" href="/iletisim"
                   onClick={(e) => { e.preventDefault(); onNavigate("contact"); }}>
              Ücretsiz analiz al
            </Dugme>
            <Dugme tur="hayalet" href="tel:+908502428674">Bizi arayın</Dugme>
          </div>
        </Ac>
      </div>
    </section>
  );
}

/* ---------- diğer hizmetler ---------- */
export function OtherServices({ currentId, onNavigate }) {
  const mobil = useMobile();
  const digerleri = serviceList.filter((s) => s.id !== currentId).slice(0, 6);
  return (
    <section style={{ padding: mobil ? "56px 0" : "84px 0" }}>
      <div style={KAP}>
        <Ac>
          <h2 style={{ fontSize: "clamp(26px,3vw,38px)", marginBottom: 14 }}>Diğer hizmetler</h2>
        </Ac>
        <Dizin>
          {digerleri.map((s, i) => (
            <Ac key={s.id}>
              <DizinSatir
                no={String(i + 1).padStart(2, "0")}
                baslik={s.title.replace(/\s*&\s*/g, " ve ")}
                aciklama={s.desc}
                href={`/hizmetler/${s.id}`}
                onClick={(e) => { e.preventDefault(); onNavigate(s.id); }}
              />
            </Ac>
          ))}
        </Dizin>
      </div>
    </section>
  );
}

export { INK_3 };
